export default {
    processing: 'Processing',
    allowed: 'Allowed',
    error: 'Error',
    blocked: 'Blocked'
};
